import { render, staticRenderFns } from "./DrugsSlider.vue?vue&type=template&id=890946b0&scoped=true"
import script from "./DrugsSlider.vue?vue&type=script&lang=js"
export * from "./DrugsSlider.vue?vue&type=script&lang=js"
import style0 from "./DrugsSlider.vue?vue&type=style&index=0&id=890946b0&prod&lang=scss&scoped=true"
import style1 from "./DrugsSlider.vue?vue&type=style&index=1&id=890946b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890946b0",
  null
  
)

export default component.exports